import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function ContactInfo() {
  const contactMethods = [{
    icon: MapPin,
    label: 'Visit Us',
    value: '13460 Baltimore Ave, Laurel, MD 20707',
    link: 'https://maps.google.com/?q=13460+Baltimore+Ave+Laurel+MD+20707'
  }, {
    icon: Phone,
    label: 'Call Us',
    value: '(301) 555-0100',
    link: 'tel:+13015550100'
  }, {
    icon: Mail,
    label: 'Email Us',
    value: 'info@houseofflavors.com',
    link: 'mailto:info@houseofflavors.com'
  }];
  const businessHours = [{
    day: 'Monday - Thursday',
    hours: '5:00 PM - 2:00 AM'
  }, {
    day: 'Friday - Saturday',
    hours: '5:00 PM - 3:00 AM'
  }, {
    day: 'Sunday',
    hours: '12:00 PM - 2:00 AM'
  }];
  const departments = [{
    name: 'VIP & Bottle Service',
    email: 'vip@houseofflavors.com',
    phone: '(301) 555-0101'
  }, {
    name: 'Private Events',
    email: 'events@houseofflavors.com',
    phone: '(301) 555-0102'
  }, {
    name: 'Corporate Inquiries',
    email: 'corporate@houseofflavors.com',
    phone: '(301) 555-0103'
  }];
  return <div className="space-y-8" data-id="element-211">
      {/* Contact Methods */}
      <div className="space-y-4" data-id="element-212">
        {contactMethods.map((method, index) => <motion.a key={method.label} href={method.link} target={method.icon === MapPin ? '_blank' : undefined} rel={method.icon === MapPin ? 'noopener noreferrer' : undefined} initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: index * 0.1
      }} className="flex items-start gap-4 p-5 bg-[#1A2228] border border-white/10 rounded-xl hover:border-[#DDA247] transition-all group" data-id="element-213">
            <div className="w-12 h-12 bg-[#DDA247]/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#DDA247]/20 transition-colors" data-id="element-214">
              <method.icon className="w-5 h-5 text-[#DDA247]" data-id="element-215" />
            </div>
            <div data-id="element-216">
              <p className="text-xs text-gray-500 uppercase tracking-widest mb-1" data-id="element-217">
                {method.label}
              </p>
              <p className="text-white font-medium group-hover:text-[#DDA247] transition-colors" data-id="element-218">
                {method.value}
              </p>
            </div>
          </motion.a>)}
      </div>

      {/* Business Hours */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3
    }} className="bg-gradient-to-br from-[#1A2228] to-[#0F161B] border border-white/10 rounded-xl p-6" data-id="element-219">
        <div className="flex items-center gap-3 mb-6" data-id="element-220">
          <div className="w-10 h-10 bg-[#DDA247]/10 rounded-lg flex items-center justify-center" data-id="element-221">
            <Clock className="w-5 h-5 text-[#DDA247]" data-id="element-222" />
          </div>
          <h3 className="text-lg font-bold text-white uppercase tracking-wide" data-id="element-223">
            Business Hours
          </h3>
        </div>
        <div className="space-y-3" data-id="element-224">
          {businessHours.map((schedule, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-white/5 last:border-0" data-id="element-225">
              <span className="text-sm text-gray-400" data-id="element-226">{schedule.day}</span>
              <span className="text-sm text-white font-medium" data-id="element-227">
                {schedule.hours}
              </span>
            </div>)}
        </div>
      </motion.div>

      {/* Departments */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="bg-gradient-to-br from-[#1A2228] to-[#0F161B] border border-white/10 rounded-xl p-6" data-id="element-228">
        <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-4" data-id="element-229">
          Direct Departments
        </h3>
        <div className="space-y-4" data-id="element-230">
          {departments.map((dept, index) => <div key={index} className="pb-4 border-b border-white/5 last:border-0 last:pb-0" data-id="element-231">
              <p className="text-white font-medium mb-2" data-id="element-232">{dept.name}</p>
              <div className="space-y-1" data-id="element-233">
                <a href={`mailto:${dept.email}`} className="text-xs text-gray-400 hover:text-[#DDA247] transition-colors block" data-id="element-234">
                  {dept.email}
                </a>
                <a href={`tel:${dept.phone.replace(/[^0-9]/g, '')}`} className="text-xs text-gray-400 hover:text-[#DDA247] transition-colors block" data-id="element-235">
                  {dept.phone}
                </a>
              </div>
            </div>)}
        </div>
      </motion.div>
    </div>;
}